import React from 'react';
import ClearButton from './ClearButton';
import {
  DesktopFilterWrapper,
  PriceInputWrapper,
  PropertyInputWrapper,
} from './DesktopFilter.style';
import PriceInputFilter from './PriceInputFilter';
import PropertyTypeInputFilter from './PropertyTypeInputFilter';
import { PropertyType } from '../../../common/helpers/domain/propertyTypes';

interface Props {
  minPrice: number;
  maxPrice: number;
  propertyType: PropertyType;
  onMinPriceChange: (minPrice: number) => void;
  onMaxPriceChange: (maxPrice: number) => void;
  onPropertyTypeChange: (propertyType: PropertyType) => void;
  onCancelSelection: () => void;
  isDisabled: boolean;
}

function DesktopFilter({
  maxPrice,
  minPrice,
  propertyType,
  onMaxPriceChange,
  onMinPriceChange,
  onPropertyTypeChange,
  onCancelSelection,
  isDisabled,
}: Props): React.ReactElement {
  return (
    <DesktopFilterWrapper isDisabled={isDisabled}>
      <PropertyInputWrapper>
        <PropertyTypeInputFilter
          currentProperty={propertyType}
          onChange={onPropertyTypeChange}
        />
      </PropertyInputWrapper>
      <PriceInputWrapper>
        <PriceInputFilter
          maxPrice={maxPrice}
          minPrice={minPrice}
          onMaxPriceChange={onMaxPriceChange}
          onMinPriceChange={onMinPriceChange}
        />
      </PriceInputWrapper>
      <ClearButton
        onCancel={onCancelSelection}
        isDisabled={!(minPrice || maxPrice || propertyType)}
      />
    </DesktopFilterWrapper>
  );
}

export default DesktopFilter;
